module.exports = __webpack_public_path__ + "img/pattern-tree.0fc5376f.svg";